module.exports = __webpack_public_path__ + "img/index-section7-award6.3a6a80e5.png";